import Icon from '../components/Icon.vue'

Icon.register({
  'trash-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 84V56C0 42.7 10.7 32 24 32H136L145.4 13.3C149.4 5.1 157.7 0 166.8 0H281.1C290.2 0 298.5 5.1 302.6 13.3L312 32H424C437.3 32 448 42.7 448 56V84C448 90.6 442.6 96 436 96H12C5.4 96 0 90.6 0 84zM416 140V464C416 490.5 394.5 512 368 512H80C53.5 512 32 490.5 32 464V140C32 133.4 37.4 128 44 128H404C410.6 128 416 133.4 416 140zM144 208C144 199.2 136.8 192 128 192S112 199.2 112 208V432C112 440.8 119.2 448 128 448S144 440.8 144 432V208zM240 208C240 199.2 232.8 192 224 192S208 199.2 208 208V432C208 440.8 215.2 448 224 448S240 440.8 240 432V208zM336 208C336 199.2 328.8 192 320 192S304 199.2 304 208V432C304 440.8 311.2 448 320 448S336 440.8 336 432V208z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/trash-alt.js
// module id = FoHd
// module chunks = 144